<script setup>
import { onMounted, ref } from 'vue';
import { VueFinalModal } from 'vue-final-modal';

const props = defineProps({
    signature: {
        type: String,
        required: true
    }
});

const emit = defineEmits(['close']);

const input = ref('');

onMounted(() => {
    input.value = props.signature;
});
</script>

<template>
    <VueFinalModal
        class="confirm-modal"
        content-class="confirm-modal-content"
        overlay-transition="vfm-fade"
        content-transition="vfm-fade"
    >
        <p class="tw-font-bold tw-mb-2 tw-text-sm">Signature (Type your name to sign)</p>
        <input v-model="input" type="text" class="input-text" />
        <button class="btn btn--green tw-mt-4" @click="emit('close', input)">Sign</button>
    </VueFinalModal>
</template>

<style>
.confirm-modal {
    display: flex;
    justify-content: center;
    align-items: center;
}

.confirm-modal-content {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    background: #fff;
    border-radius: 5px;
}
</style>

<style scoped>
.input-text {
    width: 300px;
    font-size: 20px;
    font-family: 'Yellowtail', cursive;
}
</style>
